/** @format */

import { request } from '@/utils/request';
const BASE_URL = 'powerapm';

export function getInfo() {
	return request({
		url: `powerportal/v1/portal/showTemplate`,
		type: 'get',
	});
}
export function getMenu(params) {
	return request(
		{
			url: `/base/user/context/getMenu`,
			type: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
export function getAlertLevelList() {
	return request({
		url: `poweralert/alertLevel/getAll`,
		type: 'get',
	});
}
export function subsysList(data) {
	return request<any>(
		{
			url: `/base/system/subsys/list`,
			type: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
export function getWidgetData(type, data) {
	return request<any>({
		url: `powerportal/v1'/widget/getData/${type}`,
		type: 'post',
		data,
	});
}

// 页面请求列表
export function getBrowserAnalyseListApi(params) {
	return request<any>(
		{
			url: `${BASE_URL}/custom/browserAnalyseList`,
			type: 'get',
			params,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
